import { FormatDate, FormatTime } from "./dateUtils";

export interface IAuditInfo {
  createdBy?: string | null;
  createdAt?: string | null;
  updatedBy?: string | null;
  updatedAt?: string | null;
}

// Timestamps are ISO-8601 local wall-clock (no offset/Z), microsecond precision.
const formatAuditDateTime = (dateTime?: string | null) =>
  dateTime ? `${FormatDate(dateTime)} ${FormatTime(dateTime)}` : "";

/**
 * Builds the hover-tooltip string for a row: a title (e.g. the item name)
 * followed by "kreirao"/"izmenio" audit segments.
 *
 * - "kreirao" (created) is shown when a creator username exists.
 * - "izmenio" (edited) is shown only for a genuine edit — i.e. when updatedAt
 *   differs from createdAt (on creation the backend sets them equal).
 * - Any null audit field is treated as "unknown" and its segment/timestamp is
 *   omitted, so legacy rows just show the title.
 */
export const buildAuditTooltip = (title: string, audit: IAuditInfo): string => {
  const parts = title ? [title] : [];

  if (audit.createdBy) {
    parts.push(`kreirao: ${audit.createdBy}${audit.createdAt ? ` ${formatAuditDateTime(audit.createdAt)}` : ""}`);
  }

  if (audit.updatedBy && audit.updatedAt !== audit.createdAt) {
    parts.push(`izmenio: ${audit.updatedBy}${audit.updatedAt ? ` ${formatAuditDateTime(audit.updatedAt)}` : ""}`);
  }

  return parts.join("  |  ");
};
